import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { authRoutes } from './pages/auth/auth.routing';

import { AuthGuard } from './core/auth/auth.guard';
import {CanDeactivateGuard} from './core/can-deactivate/can-deactivate.guard';
import {auditListRoutes} from './pages/audits/audit-list/audit-list.routing';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'app/pages/dashboard/dashboard.module#DashboardModule',
        data: { action: 'dashboard' }
      },

      // PROFILE
      {
        path: 'profile',
        loadChildren: 'app/pages/profile/profile.module#ProfileModule',
        data: { action: 'profile' }
      },
      // PROFILE END

      // ENTERPRISES
      {
        path: 'enterprises/mine',
        loadChildren: 'app/pages/enterprises/mine/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getMyEnterprise' }
      },
      {
        path: 'enterprises/mine/users/create',
        loadChildren: 'app/pages/enterprises/mine/create-user/create-user.module#CreateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createMyUser' }
      },
      {
        path: 'enterprises/mine/users/:id',
        loadChildren: 'app/pages/enterprises/mine/update-user/update-user.module#UpdateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateMyUser' }
      },

      {
        path: 'enterprises/audited',
        loadChildren: 'app/pages/enterprises/audited/enterprises.module#EnterprisesModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getEnterprisesAudited' }
      },
      {
        path: 'enterprises/audited/create',
        loadChildren: 'app/pages/enterprises/audited/create-enterprise/create-enterprise.module#CreateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getOneEnterpriseAudited' }
      },
      {
        path: 'enterprises/audited/:id',
        loadChildren: 'app/pages/enterprises/audited/update-enterprise/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getOneEnterpriseAudited' }
      },
      {
        path: 'enterprises/audited/:enterprise_id/users/create',
        loadChildren: 'app/pages/enterprises/audited/update-enterprise/create-user/create-user.module#CreateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createUserEnterpriseAudited' }
      },
      {
        path: 'enterprises/audited/:enterprise_id/users/:user_id',
        loadChildren: 'app/pages/enterprises/audited/update-enterprise/update-user/update-user.module#UpdateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateUserEnterpriseAudited' }
      },

      {
        path: 'enterprises/auditors',
        loadChildren: 'app/pages/enterprises/auditors/enterprises.module#EnterprisesModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getEnterprisesAuditors' }
      },
      {
        path: 'enterprises/auditors/:id',
        loadChildren: 'app/pages/enterprises/auditors/update-enterprise/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getOneEnterpriseAuditor' }
      },

      {
        path: 'enterprises/establishments',
        loadChildren: 'app/pages/enterprises/establishments/enterprises.module#EnterprisesModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getEnterprisesEstablishments' }
      },
      {
        path: 'enterprises/establishments/:id',
        loadChildren: 'app/pages/enterprises/establishments/update-enterprise/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getOneEnterpriseEstablishment' }
      },
      {
        path: 'enterprises/establishments/:enterprise_id/users/create',
        loadChildren: 'app/pages/enterprises/establishments/update-enterprise/create-user/create-user.module#CreateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createUserEnterpriseEstablishment' }
      },
      {
        path: 'enterprises/establishments/:enterprise_id/users/:user_id',
        loadChildren: 'app/pages/enterprises/establishments/update-enterprise/update-user/update-user.module#UpdateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateUserEnterpriseEstablishment' }
      },

      {
        path: 'enterprises/distributed',
        loadChildren: 'app/pages/enterprises/distributed/enterprises.module#EnterprisesModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getEnterprisesDistributed' }
      },
      {
        path: 'enterprises/distributed/:id',
        loadChildren: 'app/pages/enterprises/distributed/update-enterprise/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getOneEnterpriseDistributed' }
      },
      {
        path: 'enterprises/distributed/:enterprise_id/users/create',
        loadChildren: 'app/pages/enterprises/distributed/update-enterprise/create-user/create-user.module#CreateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createUserEnterpriseDistributed' }
      },
      {
        path: 'enterprises/distributed/:enterprise_id/users/:user_id',
        loadChildren: 'app/pages/enterprises/distributed/update-enterprise/update-user/update-user.module#UpdateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateUserEnterpriseDistributed' }
      },

      {
        path: 'enterprises',
        loadChildren: 'app/pages/enterprises/enterprises.module#EnterprisesModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'getEnterprises' }
      },
      {
        path: 'enterprises/:enterprise_id/users/create',
        loadChildren: 'app/pages/enterprises/update-enterprise/create-user/create-user.module#CreateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createUserEnterprise' }
      },
      {
        path: 'enterprises/:enterprise_id/users/:user_id',
        loadChildren: 'app/pages/enterprises/update-enterprise/update-user/update-user.module#UpdateUserModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateUserEnterprise' }
      },
      {
        path: 'enterprises/create',
        loadChildren: 'app/pages/enterprises/create-enterprise/create-enterprise.module#CreateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'createEnterprise' }
      },
      {
        path: 'enterprises/:id',
        loadChildren: 'app/pages/enterprises/update-enterprise/update-enterprise.module#UpdateEnterpriseModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateEnterprise' }
      },
      // ENTERPRISES END

      // USERS
      {
        path: 'users',
        loadChildren: 'app/pages/users/users.module#UsersModule',
        data: { action: 'getAllUsers' }
      },
      {
        path: 'users/archived',
        loadChildren: 'app/pages/users/deleted-users/deleted-users.module#DeletedUsersModule',
        data: { action: 'getArchivedUsers' }
      },
      {
        path: 'users/create/:id',
        loadChildren: 'app/pages/users/create-user/create-user.module#CreateUserModule',
        data: { action: 'createUser' }
      },
      {
        path: 'users/update/:id',
        loadChildren: 'app/pages/users/update-user/update-user.module#UpdateUserModule',
        data: { action: 'updateUser' }
      },
      // USERS END

      // FRAMES
      {
        path: 'frames',
        loadChildren: 'app/pages/frames/frames.module#FramesModule',
        data: { action: 'frames' }
      },
      {
        path: 'frames/archived',
        loadChildren: 'app/pages/frames/frames-archived/frames-archived.module#FramesArchivedModule',
        data: { action: 'archivedFrames' }
      },
      {
        path: 'frames/catalog',
        loadChildren: 'app/pages/frames/frames-catalog/frames-catalog.module#FramesCatalogModule',
        data: { action: 'catalogFrames' }
      },
      {
        path: 'frames/create',
        loadChildren: 'app/pages/frames/frames-create/frames-create.module#FramesCreateModule',
        data: { action: 'createFrame' }
      },
      {
        path: 'frames/update/:id',
        loadChildren: 'app/pages/frames/frames-edit/frames-edit.module#FramesEditModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'updateFrame' }
      },
      // FRAMES END

      // AUDITS
      ...auditListRoutes,
      {
        path: 'audit/edit/:id',
        loadChildren: 'app/pages/audits/audit-edit/audit-edit.module#AuditEditModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'editAudit' }
      },
      {
        path: 'audit-picture/edit/:id',
        loadChildren: 'app/pages/audits/audit-picture-edit/audit-picture-edit.module#AuditPictureEditModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'editAuditPicture' }
      },
      // AUDITS END

      // ACTIONS
      {
        path: 'actions/plans',
        loadChildren: 'app/pages/action-plans/plans/plans.module#PlansModule',
        canDeactivate: [CanDeactivateGuard],
        data: { action: 'plansScheduled' }
      },
      // ANCIEN - remplacé par actions/plans (page unifiée)
      // {
      //   path: 'actions/completed',
      //   loadChildren: 'app/pages/action-plans/achieved/achieved.module#AchievedModule',
      //   canDeactivate: [CanDeactivateGuard],
      //   data: { action: 'plansAchieved' }
      // },
      // {
      //   path: 'actions/progress',
      //   loadChildren: 'app/pages/action-plans/progress/progress.module#ProgressModule',
      //   canDeactivate: [CanDeactivateGuard],
      //   data: { action: 'plansProgress' }
      // },
      // {
      //   path: 'actions/scheduled',
      //   loadChildren: 'app/pages/action-plans/scheduled/scheduled.module#ScheduledModule',
      //   canDeactivate: [CanDeactivateGuard],
      //   data: { action: 'plansScheduled' }
      // },
      // ACTIONS END

      // PLANNING
      {
        path: 'planning',
        loadChildren: 'app/pages/planning/planning.module#PlanningModule',
        data: { action: 'myPlanning' }
      },
      {
        path: 'planning/enterprise',
        loadChildren: 'app/pages/planning/my-enterprise/planning.module#PlanningModule',
        data: { action: 'myEnterprisePlanning' }
      },
      {
        path: 'planning/plan',
        loadChildren: 'app/pages/planning/plan/plan.module#PlanModule',
        data: { action: 'createPlanning' }
      },
      // PLANNING END

    ]
  },
  {
    path: 'auth',
    canActivate: [AuthGuard],
    children: [
      ...authRoutes
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/app-routing.module.ts